import React from 'react';
import ReactDOM from 'react-dom';

import Application from '@views/Application';

// import Vconsole from 'vconsole';

// const vConsole = new Vconsole();

ReactDOM.render(<Application />, document.getElementById('root'));
